// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5193":"619ed880","6471":"619ed880","8708":"619ed880"}[chunkId] + ".chunk.css";
};